import { type FC } from "react";

import { CancelIcon } from "@/components/icons-lib";

interface IProps {
  onClose?: () => void;
  className?: string
  iconClassName?: string
}

const CloseButton: FC<IProps> = ({ onClose, className, iconClassName }) => {
  return (
    <button
      className={className}
      type="button"
      onClick={onClose}
    >
      <CancelIcon className={iconClassName} />
    </button>
  );
};

export default CloseButton;
